export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["In Bearbeitung"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Abgeschlossen"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ausstehend"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nächster"])}
}